import { render } from "./OpeningTimes.vue?vue&type=template&id=29e4c8f2&scoped=true"
import script from "./OpeningTimes.vue?vue&type=script&lang=js"
export * from "./OpeningTimes.vue?vue&type=script&lang=js"

import "./OpeningTimes.vue?vue&type=style&index=0&id=29e4c8f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29e4c8f2"]])

export default __exports__